module.exports = __webpack_public_path__ + "img/tickets-bg.60522462.png";